var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgA4ElectricalFire(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.14 29.85L63.25 34H53V23.65L56.64 27l5.58-7h-12.1l12.7-16h5l-9.43 12h12.79L59.14 29.85zM38.6 44.08c.89-11.54-4.48-19-12.12-21C30.64 37.39 15.24 40 14.71 52.4c-.41 9.64 6.55 13.16 14.39 14-3.17-1.21-6.22-4.23-6.65-7.62-.86-6.76 6.78-7.5 8.12-12.44a7.75 7.75 0 01-.41 10.11 9.57 9.57 0 006.58-5.12c4.32 2.94 4.92 11.25.06 14.55 14.08-5.18 14.32-19.75 5.61-28.1a7.63 7.63 0 01-3.81 6.3z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/A4_Electrical_fire.efe0898b.svg";
export { SvgA4ElectricalFire as ReactComponent };